import {
    GoogleAuthProvider,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    signInWithPopup,
    sendPasswordResetEmail,
    signOut
} from "firebase/auth";
import { auth } from "./firebaseConfig"; // Import the Firebase authentication object from FirebaseConfig
//   import { updateUserInFirestore } from "./FirebaseStore";
import api from '../services/api'
import { addMinutes, addHours } from "date-fns";

// How long a completed 2FA verification keeps you signed into the admin
// panel before ProtectedRoutes forces a fresh code. NOT how long you have
// to enter a code that was just texted (see the 15-minute expires below,
// set before verification and overwritten with this value once verified).
const SESSION_LENGTH_HOURS = 24;
const TRUSTED_DEVICE_KEY = '2FA_TRUSTED_DEVICE@ZonaAdmin';


export const handleSignUp = async (email, password, fullName) => {
    try {
        const userCredential = await createUserWithEmailAndPassword(
            auth,
            email,
            password
        );
        const { user } = userCredential;

    } catch (error) {
        console.error("Sign-up error:", error);
    }
};

export const handleSignIn = async (email, password) => {
    try {
        const userCredential = await signInWithEmailAndPassword(
            auth,
            email,
            password
        );
        const { user } = userCredential;

        if (user) {
            const idToken = await user.getIdToken();
            api.defaults.headers.authorization = `Bearer ${idToken}`;

            const { data } = await api.get(`/users/${user.uid}`);
            const { user: apiUser } = data;

            if (!apiUser.admin) {
                await auth.signOut();
                delete api.defaults.headers.authorization;
                alert('You do not have the rights to access this service.');

                return;
            }

            // The server requires the code for every admin sign-in (since 10/28),
            // so there is no path without it.
            {
                // "Remember this device" - a prior verification on THIS
                // browser, for THIS account, still inside its 30-day
                // window skips the SMS step. The server checks the device token.
                const trustedRaw = localStorage.getItem(TRUSTED_DEVICE_KEY);
                if (trustedRaw) {
                    try {
                        const trusted = JSON.parse(trustedRaw);
                        if (trusted.uid === user.uid && trusted.expires > Date.now() && typeof trusted.token === 'string') {
                            const verification = {
                                type: '2FA',
                                id: apiUser.phone,
                                verified: true,
                                expires: addHours(Date.now(), SESSION_LENGTH_HOURS).getTime(),
                            };
                            localStorage.setItem('2FA@ZonaAdmin', JSON.stringify(verification));
                            return { requires2FA: false };
                        }
                    } catch (e) {
                        // Malformed value - fall through to a normal OTP challenge.
                    }
                }

                await api.post(`/users/send-2fa-code`);

                const verification = {
                    type: '2FA',
                    id: apiUser.phone,
                    verified: false,
                    expires: addMinutes(Date.now(), 15).getTime(),
                };

                localStorage.setItem('2FA@ZonaAdmin', JSON.stringify(verification));

                return { requires2FA: true };
            }
        }

    } catch (error) {
        throw error;
    }
};

export const resetPassword = async (email) => {
    try {
        await sendPasswordResetEmail(auth, email);
    } catch (error) {
        console.log(error);
    }
};
